define(function (require, exports, module) {
    'use strict';

    var { toNDigits } = require('@mail/cross-sizes-utils');
    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     * @param {number} limit – in bytes
     */
    function UserFileSizeLimitFail(stack, source, limit) {
        UploadFail.apply(this, arguments);

        limit = toNDigits({bytes: limit, maxDigitsCount: 3}).value;
        this.message = this.message.replace('{LIMIT}', limit);
    }

    UserFileSizeLimitFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: UserFileSizeLimitFail,
        className: 'UserFileSizeLimitFail',
        radarName: 'fail_{SOURCE}_user-file-size-limit',
        message: [
            'Текущий тарифный план не позволяет загружать файлы больше {LIMIT}.',
            '<a href="https://help.mail.ru/cloud_web/size/increase" rel="noopener" target="_blank">Увеличить лимит</a>',
        ].join(' '),
    });

    module.exports = UserFileSizeLimitFail;
});
